(function () {
  if (window.__htShippingProtectionBound) return;
  window.__htShippingProtectionBound = true;

  var busy = false;
  var pendingWant = null;
  var userOptOut = false;
  var emptyStateChecked = false;

  function routes() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return {
      add: root + 'cart/add.js',
      update: root + 'cart/update.js',
      cart: root + 'cart.js'
    };
  }

  function collectSections() {
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sections }
    }));
    return sections;
  }

  function notifyImpact(data) {
    var pageType = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType;
    if (pageType === 'cart') {
      window.location.reload();
      return;
    }
    if (data && data.sections) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'ht-shipping-protection', cart: data }
      }));
      return;
    }
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function post(url, payload) {
    var sections = collectSections();
    if (sections.length) payload.sections = sections;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then(function (res) { return res.json(); });
  }

  function rootEl() {
    return document.querySelector('[data-ht-shipping-protection]');
  }

  function setBusy(on) {
    busy = on;
    document.querySelectorAll('[data-ht-sp-toggle]').forEach(function (input) {
      input.disabled = on;
    });
  }

  function flushPending() {
    setBusy(false);
    if (pendingWant === null) return;
    var next = pendingWant;
    pendingWant = null;
    sync(next);
  }

  function sync(wantOn) {
    if (busy) {
      pendingWant = wantOn;
      return;
    }
    var el = rootEl();
    if (!el) return;
    var variantId = parseInt(el.getAttribute('data-variant-id'), 10);
    var inCart = el.getAttribute('data-in-cart') === 'true';
    var hasOther = el.getAttribute('data-has-other-items') === 'true';
    var lineKey = el.getAttribute('data-line-key') || '';
    var r = routes();

    if (wantOn && !hasOther && !inCart) return;

    setBusy(true);
    if (!hasOther) userOptOut = false;
    var payload = { attributes: { shipping_protection: wantOn || !hasOther ? '1' : '0' } };
    if (!wantOn && inCart) {
      payload.updates = {};
      payload.updates[lineKey || String(variantId)] = 0;
    }

    var chain = post(r.update, payload);
    if (wantOn && !inCart && variantId) {
      chain = chain.then(function () {
        return post(r.add, { items: [{ id: variantId, quantity: 1 }] }).then(function (addData) {
          if (addData && addData.errors) {
            throw new Error(typeof addData.errors === 'string' ? addData.errors : 'cart error');
          }
          return fetch(r.cart, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
            .then(function (res) { return res.json(); })
            .then(function (cart) {
              if (addData && addData.sections) cart.sections = addData.sections;
              return cart;
            });
        });
      });
    }

    chain
      .then(function (data) {
        if (data && data.errors) {
          throw new Error(typeof data.errors === 'string' ? data.errors : 'cart error');
        }
        notifyImpact(data);
      })
      .catch(function (err) { console.warn('[ht-shipping-protection]', err); })
      .then(flushPending);
  }

  function maybeAuto() {
    if (busy) return;
    var el = rootEl();
    if (!el) {
      if (emptyStateChecked) return;
      emptyStateChecked = true;
      setBusy(true);
      fetch(routes().cart, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (!res.ok) throw new Error('Could not check the cart');
          return res.json();
        })
        .then(function (cart) {
          if (cart.item_count === 0) {
            userOptOut = false;
            if (cart.attributes && cart.attributes.shipping_protection === '0') {
              return post(routes().update, { attributes: { shipping_protection: '1' } });
            }
          }
        })
        .catch(function (err) { console.warn('[ht-shipping-protection]', err); })
        .then(flushPending)
        .then(maybeAuto);
      return;
    }
    emptyStateChecked = false;
    var optedOut = userOptOut || el.getAttribute('data-opted-out') === 'true';
    var inCart = el.getAttribute('data-in-cart') === 'true';
    var hasOther = el.getAttribute('data-has-other-items') === 'true';
    if (!optedOut && hasOther && !inCart) sync(true);
    else if (inCart && (!hasOther || optedOut)) sync(false);
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-ht-sp-toggle]')) return;
    userOptOut = !input.checked;
    var root = input.closest('[data-ht-shipping-protection]');
    if (root) root.classList.toggle('is-on', input.checked);
    sync(input.checked);
  });

  var scheduled = false;
  var mo = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      maybeAuto();
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  var initial = rootEl();
  if (initial && initial.getAttribute('data-opted-out') === 'true') userOptOut = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', maybeAuto);
  } else {
    maybeAuto();
  }
})();
